import api from "@/services/apiService";

export default {
  list(params = {}) {
    return api.get("notifications", params);
  },

  unreadCount() {
    return api.get("notifications/unread-count");
  },

  markRead(id) {
    return api.patch(`notifications/${id}/read`);
  },

  markAllRead() {
    return api.patch("notifications/read-all");
  },

  remove(id) {
    return api.delete(`notifications/${id}`);
  },

  clearAll() {
    return api.delete("notifications");
  },
};
